<template>
  <v-container>
    <generalAlert
      :alert="alert"
      :alertType="alertType"
      :message="successResponse"
    />
    <v-row>
      <!-- Mobile view col 4 -->
      <transition name="expand-fade">
        <v-col cols="12" class="text-center hidden-md-and-up" v-if="showStats">
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col cols="2"> </v-col>
                <v-col cols="8">
                  <h2 class="compeatfont">Agency Overview</h2>
                </v-col>
                <v-col cols="2" class="text-right">
                  <v-btn
                    small
                    icon
                    class="compeatsecondary"
                    @click="toggleMobileStats"
                  >
                    <v-icon small color="white">mdi-eye-off</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="cardsradius mb-5" flat v-if="!overlay">
            <v-card-text>
              <h3 class="compeatfont mb-3">
                Last Month
                {{
                  lastMonthPackageOneSubscriptions.length +
                  lastMonthPackageTwoSubscriptions.length +
                  lastMonthPackageThreeSubscriptions.length +
                  lastMonthPackageFourSubscriptions.length
                }}
                vs This month
                {{
                  packageOneSubscriptions.length +
                  packageTwoSubscriptions.length +
                  packageThreeSubscriptions.length +
                  packageFourSubscriptions.length
                }}
              </h3>
              <v-divider></v-divider>
              <v-list class="py-0" dense>
                <v-list-item-group color="primary">
                  <v-list-item class="custom-list-item">
                    <v-row justify="center" align="center">
                      <v-col cols="5" class="text-left"> Package 1 </v-col>
                      <v-col cols="3" class="text-center">
                        <p class="compeatfont mb-0">
                          {{ this.lastMonthPackageOneSubscriptions.length }}
                        </p>
                      </v-col>
                      <v-col cols="4" class="text-center">
                        <v-chip
                          v-if="
                            this.packageOneSubscriptions.length >
                            this.lastMonthPackageOneSubscriptions.length
                          "
                          small
                          class="ma-2"
                          color="success"
                          text-color="white"
                        >
                          <v-icon small left> mdi-arrow-up-bold </v-icon>
                          {{ this.packageOneSubscriptions.length }}
                        </v-chip>
                        <v-chip
                          v-else
                          small
                          class="ma-2"
                          color="error"
                          text-color="white"
                        >
                          <v-icon small left> mdi-arrow-down-bold </v-icon>
                          {{ this.packageOneSubscriptions.length }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item class="custom-list-item">
                    <v-row justify="center" align="center">
                      <v-col cols="5" class="text-left"> Package 2 </v-col>
                      <v-col cols="3" class="text-center">
                        <p class="compeatfont mb-0">
                          {{ this.lastMonthPackageTwoSubscriptions.length }}
                        </p>
                      </v-col>
                      <v-col cols="4" class="text-center">
                        <v-chip
                          v-if="
                            this.packageTwoSubscriptions.length >
                            this.lastMonthPackageTwoSubscriptions.length
                          "
                          small
                          class="ma-2"
                          color="success"
                          text-color="white"
                        >
                          <v-icon small left> mdi-arrow-up-bold </v-icon>
                          {{ this.packageTwoSubscriptions.length }}
                        </v-chip>
                        <v-chip
                          v-else
                          small
                          class="ma-2"
                          color="error"
                          text-color="white"
                        >
                          <v-icon small left> mdi-arrow-down-bold </v-icon>
                          {{ this.packageTwoSubscriptions.length }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item class="custom-list-item">
                    <v-row justify="center" align="center">
                      <v-col cols="5" class="text-left"> Package 3 </v-col>
                      <v-col cols="3" class="text-center">
                        <p class="compeatfont mb-0">
                          {{ this.lastMonthPackageThreeSubscriptions.length }}
                        </p>
                      </v-col>
                      <v-col cols="4" class="text-center">
                        <v-chip
                          v-if="
                            this.packageThreeSubscriptions.length >
                            this.lastMonthPackageThreeSubscriptions.length
                          "
                          small
                          class="ma-2"
                          color="success"
                          text-color="white"
                        >
                          <v-icon small left> mdi-arrow-up-bold </v-icon>
                          {{ this.packageThreeSubscriptions.length }}
                        </v-chip>
                        <v-chip
                          v-else
                          small
                          class="ma-2"
                          color="error"
                          text-color="white"
                        >
                          <v-icon small left> mdi-arrow-down-bold </v-icon>
                          {{ this.packageThreeSubscriptions.length }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item class="custom-list-item">
                    <v-row justify="center" align="center">
                      <v-col cols="5" class="text-left"> Package 4 </v-col>
                      <v-col cols="3" class="text-center">
                        <p class="compeatfont mb-0">
                          {{ this.lastMonthPackageFourSubscriptions.length }}
                        </p>
                      </v-col>
                      <v-col cols="4" class="text-center">
                        <v-chip
                          v-if="
                            this.packageFourSubscriptions.length >
                            this.lastMonthPackageFourSubscriptions.length
                          "
                          small
                          class="ma-2"
                          color="success"
                          text-color="white"
                        >
                          <v-icon small left> mdi-arrow-up-bold </v-icon>
                          {{ this.packageFourSubscriptions.length }}
                        </v-chip>
                        <v-chip
                          v-else
                          small
                          class="ma-2"
                          color="error"
                          text-color="white"
                        >
                          <v-icon small left> mdi-arrow-down-bold </v-icon>
                          {{ this.packageFourSubscriptions.length }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
          </v-card>
          <v-skeleton-loader
            v-if="overlay"
            height="372px"
            class="mx-auto mb-5"
            type="image"
          >
          </v-skeleton-loader>
          <v-card v-if="!overlay" class="cardsradius" flat>
            <v-card-text>
              <h3
                class="compeatfont mb-3"
                v-if="this.$store.state.user.userType == 'AA'"
              >
                All Time Purchased Ratio
              </h3>
              <h3
                class="compeatfont mb-3"
                v-if="this.$store.state.user.userType == 'SMM'"
              >
                All Time Purchased Ratio
              </h3>
              <v-divider class="mb-3"></v-divider>
              <apexchart
                type="donut"
                height="350"
                :options="chartOptionsPackages"
                :series="seriesPackages"
              ></apexchart>
            </v-card-text>
          </v-card>
          <v-skeleton-loader v-else height="372px" class="mx-auto" type="image">
          </v-skeleton-loader>
        </v-col>
      </transition>
      <!-- Desktop view col 8 -->
      <v-col
        class="hidden-sm-and-down"
        cols="8"
        :class="{ 'col-12': expandCol8 }"
      >
        <v-card v-if="!overlay" flat class="py-3 px-3">
          <v-card-text class="pt-0">
            <v-row justify="center" align="center">
              <v-col cols="6">
                <h2 class="compeatfont">Active Subscriptions</h2>
              </v-col>
              <v-col cols="6" class="text-right">
                <v-btn
                  small
                  icon
                  class="compeatsecondary hidden-sm-and-down"
                  v-if="!showCol4 && this.$store.state.user.userType == 'AA'"
                  @click="toggleColumns"
                >
                  <v-icon small color="white">mdi-chart-gantt</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-title class="pt-0">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search Clients name, Company name or Date"
              single-line
              hide-details
              class="pt-0"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn @click="createDemoReport()" class="primary" small rounded
              >Create Demo</v-btn
            >
            <createNewSubscription :selectPackage="selectPackageNoTrial" />
          </v-card-title>
          <v-data-table
            v-if="this.$store.state.user.userType == 'RS'"
            :headers="headers"
            :items="resellerActiveSubscriptions"
            :search="search"
            :items-per-page="10"
            :loading="tableLoading"
            loading-text="Loading... Please wait"
          >
            <template v-slot:[`item.package`]="{ item }">
              {{ item.package.currentPackage }}
            </template>
            <template v-slot:[`item.isActive`]="{ item }">
              <v-chip class="ma-2" color="success"> Active </v-chip>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-btn @click="viewSubscription(item)" icon color="primary"
                ><v-icon>mdi-eye</v-icon></v-btn
              >
            </template>
          </v-data-table>
          <v-data-table
            v-if="
              this.$store.state.user.userType == 'AS' ||
              this.$store.state.user.userType == 'SMM' ||
              this.$store.state.user.userType == 'AA'
            "
            :headers="headers"
            :items="agencyActiveSubscriptions"
            :search="search"
            :items-per-page="10"
            :loading="tableLoading"
            loading-text="Loading... Please wait"
          >
            <template v-slot:[`item.package`]="{ item }">
              {{ item.package.currentPackage }}
            </template>

            <template v-slot:[`item.competitiveReport`]="{ item }">
              <v-icon
                v-if="item.reportIds.competitiveReportIds != ''"
                color="primary"
                @click="
                  viewCompetitiveReport(
                    item,
                    item.reportIds.competitiveReportIds[0].reportId
                  )
                "
                >mdi-eye</v-icon
              >
              <p class="mb-0" v-else>N/A</p>
            </template>

            <template v-slot:[`item.insightsFb`]="{ item }">
              <v-icon
                v-if="item.reportIds.insightsReportIds != ''"
                color="primary"
                @click="
                  viewFbReport(
                    item,
                    item.reportIds.insightsReportIds[0].reportId
                  )
                "
                >mdi-eye</v-icon
              >
              <p class="mb-0" v-else>N/A</p>
            </template>

            <template v-slot:[`item.insightsIg`]="{ item }">
              <v-icon
                v-if="item.reportIds.instagramReportIds != ''"
                color="primary"
                @click="
                  viewIgReport(
                    item,
                    item.reportIds.instagramReportIds[0].reportId
                  )
                "
                >mdi-eye</v-icon
              >
              <p class="mb-0" v-else>N/A</p>
            </template>

            <template v-slot:[`item.isActive`]="{ item }">
              <v-chip class="ma-2" color="success"> Active </v-chip>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark icon v-bind="attrs" v-on="on">
                    <v-icon color="primary">mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item @click="viewSubscription(item)">
                    <v-list-item-title
                      ><v-icon class="mr-1" color="primary">mdi-eye</v-icon>
                      View Subscription</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
        <v-skeleton-loader
          v-else
          height="372px"
          class="mx-auto"
          type="table-heading, table-thead, table-tbody, table-tfoot"
        >
        </v-skeleton-loader>
      </v-col>
      <!-- mobile view col 8 -->
      <v-col cols="12" class="hidden-md-and-up">
        <v-card v-if="!overlay" flat class="py-3 px-3">
          <v-row>
            <v-col cols="10" sm="10" md="6" lg="6">
              <h2 class="compeatfont">Active Subscriptions</h2>
            </v-col>
            <v-col cols="2" sm="2" md="6" lg="6">
              <v-btn
                  small
                  icon
                  class="compeatsecondary"
                  @click="toggleMobileStats"
                  v-if="!showStats && this.$store.state.user.userType === 'AA'"
                >
                  <v-icon small color="white">mdi-chart-gantt</v-icon>
                </v-btn>
            </v-col>
            <v-col cols="12" sm="12" md="8" lg="8" class="hidden-sm-and-down">
                <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search Clients name, Company name or Date"
                single-line
                hide-details
                class="pt-0"
              ></v-text-field>
            </v-col>
            <v-col cols="5" sm="5" md="2" lg="2" class="text-center">
              <v-btn @click="createDemoReport()" class="primary" small rounded
              >Create Demo</v-btn
              >
            </v-col>
            <v-col cols="5" sm="5" md="2" lg="2" class="text-center">
              <createNewSubscription :selectPackage="selectPackageNoTrial"  />
            </v-col>
            <v-col cols="12" sm="12" md="8" lg="8" class="hidden-sm-and-up">
              <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search Clients name, Company name or Date"
              single-line
              hide-details
              class="pt-2"
            ></v-text-field>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="agencyActiveSubscriptions"
            :search="search"
            :items-per-page="10"
            :loading="tableLoading"
            loading-text="Loading... Please wait"
          >
            <template v-slot:[`item.package`]="{ item }">
              {{ item.package.currentPackage }}
            </template>
            <template v-slot:[`item.competitiveReport`]="{ item }">
              <v-icon
                v-if="item.reportIds.competitiveReportIds != ''"
                color="primary"
                @click="
                  viewCompetitiveReport(
                    item,
                    item.reportIds.competitiveReportIds[0].reportId
                  )
                "
                >mdi-eye</v-icon
              >
              <p class="mb-0" v-else>N/A</p>
            </template>
            <template v-slot:[`item.insightsFb`]="{ item }">
              <v-icon
                v-if="item.reportIds.insightsReportIds != ''"
                color="primary"
                @click="
                  viewFbReport(
                    item,
                    item.reportIds.insightsReportIds[0].reportId
                  )
                "
                >mdi-eye</v-icon
              >
              <p class="mb-0" v-else>N/A</p>
            </template>

            <template v-slot:[`item.insightsIg`]="{ item }">
              <v-icon
                v-if="item.reportIds.instagramReportIds != ''"
                color="primary"
                @click="
                  viewIgReport(
                    item,
                    item.reportIds.instagramReportIds[0].reportId
                  )
                "
                >mdi-eye</v-icon
              >
              <p class="mb-0" v-else>N/A</p>
            </template>
            <template v-slot:[`item.isActive`]="{ item }">
              <v-chip class="ma-2" color="success"> Active </v-chip>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark icon v-bind="attrs" v-on="on">
                    <v-icon color="primary">mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item @click="viewSubscription(item)">
                    <v-list-item-title
                      ><v-icon class="mr-1" color="primary">mdi-eye</v-icon>
                      View Subscription</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
        <v-skeleton-loader
          v-else
          height="372px"
          class="mx-auto"
          type="table-heading, table-thead, table-tbody, table-tfoot"
        >
        </v-skeleton-loader>
      </v-col>
      <!-- Desktop view col 4 -->
      <transition name="expand-fade">
        <v-col cols="4" class="text-center hidden-sm-and-down" v-if="showCol4">
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col cols="2" class="text-left">
                  <v-btn
                    small
                    icon
                    class="compeatsecondary"
                    v-if="showCol4"
                    @click="toggleColumns"
                  >
                    <v-icon small color="white">mdi-eye-off</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="8">
                  <h2 class="compeatfont">Agency Overview</h2>
                </v-col>
                <v-col cols="2"> </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="cardsradius mb-5" flat v-if="!overlay">
            <v-card-text>
              <h3 class="compeatfont mb-3">
                Last Month
                {{
                  lastMonthPackageOneSubscriptions.length +
                  lastMonthPackageTwoSubscriptions.length +
                  lastMonthPackageThreeSubscriptions.length +
                  lastMonthPackageFourSubscriptions.length
                }}
                vs This month
                {{
                  packageOneSubscriptions.length +
                  packageTwoSubscriptions.length +
                  packageThreeSubscriptions.length +
                  packageFourSubscriptions.length
                }}
              </h3>
              <v-divider></v-divider>
              <v-list class="py-0" dense>
                <v-list-item-group color="primary">
                  <v-list-item class="custom-list-item">
                    <v-row justify="center" align="center">
                      <v-col cols="5" class="text-left"> Package 1 </v-col>
                      <v-col cols="3" class="text-center">
                        <p class="compeatfont mb-0">
                          {{ this.lastMonthPackageOneSubscriptions.length }}
                        </p>
                      </v-col>
                      <v-col cols="4" class="text-center">
                        <v-chip
                          v-if="
                            this.packageOneSubscriptions.length >
                            this.lastMonthPackageOneSubscriptions.length
                          "
                          small
                          class="ma-2"
                          color="success"
                          text-color="white"
                        >
                          <v-icon small left> mdi-arrow-up-bold </v-icon>
                          {{ this.packageOneSubscriptions.length }}
                        </v-chip>
                        <v-chip
                          v-else
                          small
                          class="ma-2"
                          color="error"
                          text-color="white"
                        >
                          <v-icon small left> mdi-arrow-down-bold </v-icon>
                          {{ this.packageOneSubscriptions.length }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item class="custom-list-item">
                    <v-row justify="center" align="center">
                      <v-col cols="5" class="text-left"> Package 2 </v-col>
                      <v-col cols="3" class="text-center">
                        <p class="compeatfont mb-0">
                          {{ this.lastMonthPackageTwoSubscriptions.length }}
                        </p>
                      </v-col>
                      <v-col cols="4" class="text-center">
                        <v-chip
                          v-if="
                            this.packageTwoSubscriptions.length >
                            this.lastMonthPackageTwoSubscriptions.length
                          "
                          small
                          class="ma-2"
                          color="success"
                          text-color="white"
                        >
                          <v-icon small left> mdi-arrow-up-bold </v-icon>
                          {{ this.packageTwoSubscriptions.length }}
                        </v-chip>
                        <v-chip
                          v-else
                          small
                          class="ma-2"
                          color="error"
                          text-color="white"
                        >
                          <v-icon small left> mdi-arrow-down-bold </v-icon>
                          {{ this.packageTwoSubscriptions.length }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item class="custom-list-item">
                    <v-row justify="center" align="center">
                      <v-col cols="5" class="text-left"> Package 3 </v-col>
                      <v-col cols="3" class="text-center">
                        <p class="compeatfont mb-0">
                          {{ this.lastMonthPackageThreeSubscriptions.length }}
                        </p>
                      </v-col>
                      <v-col cols="4" class="text-center">
                        <v-chip
                          v-if="
                            this.packageThreeSubscriptions.length >
                            this.lastMonthPackageThreeSubscriptions.length
                          "
                          small
                          class="ma-2"
                          color="success"
                          text-color="white"
                        >
                          <v-icon small left> mdi-arrow-up-bold </v-icon>
                          {{ this.packageThreeSubscriptions.length }}
                        </v-chip>
                        <v-chip
                          v-else
                          small
                          class="ma-2"
                          color="error"
                          text-color="white"
                        >
                          <v-icon small left> mdi-arrow-down-bold </v-icon>
                          {{ this.packageThreeSubscriptions.length }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item class="custom-list-item">
                    <v-row justify="center" align="center">
                      <v-col cols="5" class="text-left"> Package 4 </v-col>
                      <v-col cols="3" class="text-center">
                        <p class="compeatfont mb-0">
                          {{ this.lastMonthPackageFourSubscriptions.length }}
                        </p>
                      </v-col>
                      <v-col cols="4" class="text-center">
                        <v-chip
                          v-if="
                            this.packageFourSubscriptions.length >
                            this.lastMonthPackageFourSubscriptions.length
                          "
                          small
                          class="ma-2"
                          color="success"
                          text-color="white"
                        >
                          <v-icon small left> mdi-arrow-up-bold </v-icon>
                          {{ this.packageFourSubscriptions.length }}
                        </v-chip>
                        <v-chip
                          v-else
                          small
                          class="ma-2"
                          color="error"
                          text-color="white"
                        >
                          <v-icon small left> mdi-arrow-down-bold </v-icon>
                          {{ this.packageFourSubscriptions.length }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item class="custom-list-item">
                    <v-row justify="center" align="center">
                      <v-col cols="5" class="text-left"> Package 5 </v-col>
                      <v-col cols="3" class="text-center">
                        <p class="compeatfont mb-0">
                          {{ this.lastMonthPackageFiveSubscriptions.length }}
                        </p>
                      </v-col>
                      <v-col cols="4" class="text-center">
                        <v-chip
                          v-if="
                            this.packageFiveSubscriptions.length >
                            this.lastMonthPackageFiveSubscriptions.length
                          "
                          small
                          class="ma-2"
                          color="success"
                          text-color="white"
                        >
                          <v-icon small left> mdi-arrow-up-bold </v-icon>
                          {{ this.packageFiveSubscriptions.length }}
                        </v-chip>
                        <v-chip
                          v-else
                          small
                          class="ma-2"
                          color="error"
                          text-color="white"
                        >
                          <v-icon small left> mdi-arrow-down-bold </v-icon>
                          {{ this.packageFiveSubscriptions.length }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
          </v-card>
          <v-skeleton-loader
            v-if="overlay"
            height="372px"
            class="mx-auto mb-5"
            type="image"
          >
          </v-skeleton-loader>
          <v-card v-if="!overlay" class="cardsradius" flat>
            <v-card-text>
              <h3
                class="compeatfont mb-3"
                v-if="this.$store.state.user.userType == 'AA'"
              >
                All Time Purchased Ratio
              </h3>
              <h3
                class="compeatfont mb-3"
                v-if="this.$store.state.user.userType == 'SMM'"
              >
                All Time Purchased Ratio
              </h3>
              <v-divider class="mb-3"></v-divider>
              <apexchart
                type="donut"
                height="350"
                :options="chartOptionsPackages"
                :series="seriesPackages"
              ></apexchart>
            </v-card-text>
          </v-card>
          <v-skeleton-loader v-else height="372px" class="mx-auto" type="image">
          </v-skeleton-loader>
        </v-col>
      </transition>
    </v-row>
  </v-container>
</template>

<script>
import generalAlert from "../components/alerts/generalAlert.vue";
import createNewSubscription from "../components/dialogs/createNewSubscription.vue";
import { firebaseApp } from "../firebaseConfig";
import {
  getFirestore,
  query,
  collection,
  where,
  getDocs,
  getDoc,
  doc,
} from "firebase/firestore";
import moment from "moment-timezone";

const db = getFirestore(firebaseApp);
export default {
  components: {
    generalAlert,
    createNewSubscription,
  },
  data: () => ({
    overlay: false,
    drawer: false,

    value: "",

    //Table data and info
    agencyActiveSubscriptions: [],
    resellerActiveSubscriptions: [],
    tableLoading: false,
    search: "",
    headers: [
      { text: "Client", value: "name", sortable: false, align: "center" },
      {
        text: "Company",
        sortable: false,
        value: "package.primaryPage.name",
        align: "center",
      },
      { text: "Package", sortable: false, value: "package", align: "center" },
      {
        text: "Date Created",
        value: "dateCreated",
        sortable: true,
        align: "center",
      },
      {
        text: "Competitive Report",
        value: "competitiveReport",
        sortable: false,
        align: "center",
      },
      {
        text: "Insights FB",
        value: "insightsFb",
        sortable: false,
        align: "center",
      },
      {
        text: "Insights IG",
        value: "insightsIg",
        sortable: false,
        align: "center",
      },
      { text: "Status", value: "isActive", sortable: false, align: "center" },
      { text: "Action", value: "action", sortable: false, align: "center" },
    ],

    //Data for pir chart
    seriesPackages: [],
    chartOptionsPackages: {},

    //top Agent
    topAgents: [],
    displayedTopAgents: [],
    itemsToShow: 5,
    itemsToShowIncrement: 5,

    // Initially show col-4 - col-8 is not expanded
    showCol4: true,
    expandCol8: false,

    // mobile stats
    showStats: false,

    //Alert for new subscription
    successResponse: "",
    alertType: "",
    alert: false,

    testItems: [{ name: "Dane Topham" }, { name: "Daneson Topham" }],

    //Packages array
    packageOneSubscriptions: [],
    packageTwoSubscriptions: [],
    packageThreeSubscriptions: [],
    packageFourSubscriptions: [],
    packageFiveSubscriptions: [],

    lastMonthPackageOneSubscriptions: [],
    lastMonthPackageTwoSubscriptions: [],
    lastMonthPackageThreeSubscriptions: [],
    lastMonthPackageFourSubscriptions: [],
    lastMonthPackageFiveSubscriptions: [],

    selectPackageNoTrial: [
      { text: "Guardian Package", value: "package-1" },
      { text: "Spark Package", value: "package-2" },
      { text: "Pulse Package", value: "package-3" },
    ]
  }),
  created() {
    // Set the overlay to true by default
    this.overlay = true;

    // Check if the user is signed in and has an agencyId
    if (
      this.$store.state.user.agencyId &&
      this.$store.state.loggedIntoFacebook
    ) {
      if (this.$store.state.user.userType === "SMM") {
        // User is an SMM
        this.showCol4 = false;
        this.expandCol8 = true;
        // Perform some actions for signed-in users
        this.getAgencyActiveSubscriptions();
      } else if (this.$store.state.user.userType === "AA") {
        // User is an AA
        this.showCol4 = false;
        this.expandCol8 = true;
        // Perform some actions for signed-in users
        this.getAgencyActiveSubscriptions();
      } else if (this.$store.state.user.userType === "RS") {
        // User is an RS
        this.showCol4 = false;
        this.expandCol8 = true;
        this.getResellerSubscriptions();
      }
    } else {
      // User is not signed in
      if (confirm("You are not signed in. Do you want to log in?")) {
        this.redirectToLogin();
      } else {
        this.redirectToLogin();
      }
    }
  },
  methods: {
    toggleColumns() {
      this.showCol4 = !this.showCol4;
      this.expandCol8 = !this.expandCol8;
    },
    toggleMobileStats() {
      this.showStats = !this.showStats;
    },
    //show more top agents
    showMore() {
      this.itemsToShow += this.itemsToShowIncrement;
    },
    // Redirect to the login page using Vue Router.
    redirectToLogin() {
      this.$router.push("/login");
    },
    //Gets all the active subscriptions and formats by date and formats data for pie chart
    async getAgencyActiveSubscriptions() {
      this.tableLoading = true;
      this.agencyActiveSubscriptions = [];
      this.agencyDemoSubscriptions = [];
      this.packageOneSubscriptions = [];
      this.packageTwoSubscriptions = [];
      this.packageThreeSubscriptions = [];
      this.packageFourSubscriptions = [];
      this.packageFiveSubscriptions = [];

      this.lastMonthPackageOneSubscriptions = [];
      this.lastMonthPackageTwoSubscriptions = [];
      this.lastMonthPackageThreeSubscriptions = [];
      this.lastMonthPackageFourSubscriptions = [];
      this.lastMonthPackageFiveSubscriptions = [];

      // Get the current month and year
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1; // Month is 0-based, so add 1
      const lastMonth = currentMonth === 1 ? 12 : currentMonth - 1; // Calculate last month

      try {
        const q = query(
          collection(db, "subscriptions"),
          where("agencyId", "==", this.$store.state.user.agencyId)
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          let subscription = doc.data();
          let createdMilliseconds = subscription.dateCreated;
          let formatCreatedDate =
            moment(createdMilliseconds).format("YYYY-MM-DD h:mm a");
          subscription.dateCreated = formatCreatedDate;

          //checks to see if user is AA or SMM
          if (
            subscription.isActive == true &&
            subscription.agencyUser == this.$store.state.user.id &&
            this.$store.state.user.userType == "SMM" &&
            subscription.package.packageType == "CompEatPaid"
          ) {
            this.agencyActiveSubscriptions.push(subscription);
            this.showCol4 = false;
            this.expandCol8 = true;
          } else if (
            subscription.isActive == true &&
            this.$store.state.user.userType == "AA" &&
            subscription.package.packageType == "CompEatPaid"
          ) {
            this.agencyActiveSubscriptions.push(subscription);
          }

          // Sort the array by date
          this.agencyActiveSubscriptions.sort((a, b) => {
            return new Date(b.dateCreated) - new Date(a.dateCreated);
          });

          // Check if the subscription was purchased this month
          const purchaseDate = new Date(createdMilliseconds);
          if (
            purchaseDate.getFullYear() === currentYear &&
            purchaseDate.getMonth() + 1 === currentMonth
          ) {
            if (
              subscription.package.currentPackage === "Package 1" &&
              subscription.package.packageType == "CompEatPaid"
            ) {
              this.packageOneSubscriptions.push(subscription);
            } else if (
              subscription.package.currentPackage === "Package 2" &&
              subscription.package.packageType == "CompEatPaid"
            ) {
              this.packageTwoSubscriptions.push(subscription);
            } else if (
              subscription.package.currentPackage === "Package 3" &&
              subscription.package.packageType == "CompEatPaid"
            ) {
              this.packageThreeSubscriptions.push(subscription);
            } else if (subscription.package.currentPackage === "Package 4") {
              this.packageFourSubscriptions.push(subscription);
            } else if (subscription.package.currentPackage === "Package 5") {
              this.packageFiveSubscriptions.push(subscription);
            }
          } else if (
            purchaseDate.getFullYear() === currentYear &&
            purchaseDate.getMonth() + 1 === lastMonth
          ) {
            if (
              subscription.package.currentPackage === "Package 1" &&
              subscription.package.packageType == "CompEatPaid"
            ) {
              this.lastMonthPackageOneSubscriptions.push(subscription);
            } else if (
              subscription.package.currentPackage === "Package 2" &&
              subscription.package.packageType == "CompEatPaid"
            ) {
              this.lastMonthPackageTwoSubscriptions.push(subscription);
            } else if (
              subscription.package.currentPackage === "Package 3" &&
              subscription.package.packageType == "CompEatPaid"
            ) {
              this.lastMonthPackageThreeSubscriptions.push(subscription);
            } else if (subscription.package.currentPackage === "Package 4") {
              this.lastMonthPackageFourSubscriptions.push(subscription);
            } else if (subscription.package.currentPackage === "Package 5") {
              this.lastMonthPackageFiveSubscriptions.push(subscription);
            }
          }
        });

        //below data  and formating is for the pie graph
        const [headings, counts] = await this.processSubscriptions(
          this.agencyActiveSubscriptions
        );

        this.seriesPackages = counts;
        this.chartOptionsPackages = {
          labels: headings,
          dataLabels: {
            enabled: false,
          },
          responsive: [
            {
              breakpoint: 960,
              options: {
                chart: {
                  width: 290,
                },
                legend: {
                  show: true,
                },
              },
            },
          ],
          legend: {
            position: "bottom",
          },
        };
        this.overlay = false;
        this.tableLoading = false;

        

        // this.countAgencyUserIds();
      } catch (err) {
        console.log("getAgencyActiveSubscriptions err", err);
        this.isLoading = false;
      }
    },
    //Get Reseller Subscriptions
    async getResellerSubscriptions() {
      this.resellerActiveSubscriptions = [];
      this.tableLoading = true;
      const q = query(
        collection(db, "subscriptions"),
        where("agencyId", "==", this.$store.state.user.agencyId)
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        let subscription = doc.data();

        let createdMilliseconds = subscription.dateCreated;
        let formatCreatedDate =
          moment(createdMilliseconds).format("YYYY-MM-DD h:mm a");
        subscription.dateCreated = formatCreatedDate;

        if (
          subscription.resellerUid === this.$store.state.user.resellerUid &&
          subscription.isActive === true
        ) {
          this.resellerActiveSubscriptions.push(subscription);
        }
      });

      // Sort the array by date
      this.resellerActiveSubscriptions.sort((a, b) => {
        return new Date(b.dateCreated) - new Date(a.dateCreated);
      });
      console.log("Active subscription", this.resellerActiveSubscriptions);
      this.tableLoading = false;
      this.overlay = false;
    },
    //this processes the data for the pie chart above
    async processSubscriptions(subscriptions) {
      const packageCounts = {};

      subscriptions.forEach((subscription) => {
        const currentPackage = subscription.package.currentPackage;
        if (currentPackage) {
          if (packageCounts[currentPackage]) {
            packageCounts[currentPackage]++;
          } else {
            packageCounts[currentPackage] = 1;
          }
        }
      });

      const headings = Object.keys(packageCounts);
      const counts = Object.values(packageCounts);

      return [headings, counts];
    },
    //View the subscription
    viewSubscription(item) {
      this.$router.push({
        name: "singleSubscription",
        params: {
          id: this.$store.state.user.agencyId,
          uid: item.uid,
        },
      });
    },
    viewCompetitiveReport(item, reportId) {
      this.$router.push({
        name: "singleReport",
        params: {
          id: item.agencyId,
          uid: item.uid,
          reportId: reportId,
        },
      });
    },
    viewFbReport(item, reportId) {
      this.$router.push({
        name: "insightsReport",
        params: {
          id: item.agencyId,
          uid: item.uid,
          reportId: reportId,
        },
      });
    },
    viewIgReport(item, reportId) {
      this.$router.push({
        name: "instagramInsightsReport",
        params: {
          id: item.agencyId,
          uid: item.uid,
          reportId: reportId,
        },
      });
    },
    //Alert for the new subscription
    successAlert(message, typeOfAlert) {
      this.successResponse = message;
      this.alertType = typeOfAlert;
      this.alert = true;
      setTimeout(() => {
        this.alert = false;
        if (this.$store.state.user.resellerUid) {
          this.getResellerSubscriptions();
        } else {
          this.getAgencyActiveSubscriptions();
        }
      }, 5000);
    },
    createDemoReport() {
      this.$router.push({
        name: "createSingleSubscription",
        params: {
          title: "package-demo",
        },
      });
    },
  },
};
</script>

<style scoped>
.cardsradius {
  border-radius: 20px !important;
  box-shadow: rgb(204, 219, 232) 3px 3px 6px 0px inset,
    rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset !important;
}

.custom-list-item:not(:last-child) {
  border-bottom: 1px solid #e0e0e0; /* Adjust the border style and color as needed */
}

.expand-fade-enter-active,
.expand-fade-leave-active {
  transition: opacity 0.5s !important; /* Adjust the duration as needed */
}
.expand-fade-enter, .expand-fade-leave-to /* .expand-fade-leave-active in <2.1.8 */ {
  opacity: 0 !important;
}

.v-menu__content {
  width: 200px;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
    padding: 0px important;
    transition: height 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}
</style>
